// src/utils/routeHelpers.js
export function withCountryPrefix(path, country) {
  if (!country) return path;
  // αφαίρεσε αρχικό slash αν υπάρχει
  const clean = path.startsWith("/") ? path.slice(1) : path;
  return `/${country}/${clean}`;
}

export function withQuery(path, params = {}) {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value == null || value === "") return;
    query.set(key, String(value));
  });

  const qs = query.toString();
  return qs ? `${path}?${qs}` : path;
}
